import $ from "jquery";
import _ from "lodash";
import { modal } from "./modal";
import { EventEmitter } from "../events/eventEmitter";
const visibleClass = "accordian-table-tr-visible";
class AccordionTable extends EventEmitter {
    constructor() {
        super();
        modal.on("show", (m) => this.initialise(m));
        $(() => this.initialise(document));
    }
    initialise(container) {
        $("[data-accordian-table-target]", container)
            .toArray()
            .forEach((t) => {
            const trigger = $(t);
            const target = $(trigger.data("accordian-table-target"), container);
            const targetExpandedSearchParameter = trigger.data("accordian-table-expanded-search-parameter");
            const targetId = target.prop("id");
            const toggle = () => {
                const targetVisible = target.hasClass(visibleClass);
                if (targetExpandedSearchParameter && targetId) {
                    const url = new URL(window.location.href);
                    targetVisible
                        ? url.searchParams.delete(targetExpandedSearchParameter)
                        : url.searchParams.set(targetExpandedSearchParameter, targetId);
                    history.pushState({}, "", url.href);
                }
                target.toggleClass(visibleClass);
                target.attr("aria-expanded", `${!targetVisible}`);
                target.prop("inert", targetVisible);
                trigger.is("[data-ajax-content-target][data-ajax-content-url]") &&
                    this.loadContent(trigger);
            };
            trigger
                .prop("tabIndex", "0")
                .on("keydown", (e) => {
                if (_.some($(e.target).parents("[data-accordian-table-ignore]")))
                    return;
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    toggle();
                }
            })
                .on("click", (e) => {
                if (_.some($(e.target).parents("[data-accordian-table-ignore]")))
                    return;
                toggle();
            });
        });
        $(container)
            .find("[data-ajax-content-auto-load='True']")
            .toArray()
            .forEach((t) => this.loadContent($(t)));
    }
    async loadContent(trigger) {
        if (trigger.data("content-loaded"))
            return;
        const target = $(trigger.data("ajax-content-target"));
        const url = trigger.data("ajax-content-url");
        const response = await fetch(url, {
            headers: { "X-Requested-With": "XMLHttpRequest" },
        });
        if (response.ok) {
            target.html(await response.text());
            this.emit("load", target[0]);
            this.initialise(target[0]);
            trigger.data("content-loaded", true);
        }
    }
}
export const accordionTable = new AccordionTable();
